import { supabase } from './supabase';

/**
 * Nome oficial (Receita) de um CPF/CNPJ, pela edge function consultar-cpf-cnpj.
 *
 * Cada consulta é paga (cpfcnpj.com.br): só é chamada quando os nomes de um mesmo
 * documento parecem de pessoas diferentes (#6160), e o resultado fica guardado
 * enquanto a página estiver aberta. Falha, demora acima de 8s ou documento não
 * encontrado devolvem null — quem chama volta para a comparação de nomes.
 */
const cache = new Map<string, Promise<string | null>>();
const LIMITE_MS = 8000;

export function nomeOficialDocumento(documento: string): Promise<string | null> {
    const doc = documento.replace(/\D/g, '');
    if (doc.length !== 11 && doc.length !== 14) return Promise.resolve(null);
    const emCache = cache.get(doc);
    if (emCache) return emCache;

    const consulta = (async () => {
        try {
            const { data, error } = await supabase.functions.invoke('consultar-cpf-cnpj', {
                body: { document: doc, type: doc.length === 11 ? 'cpf' : 'cnpj' },
            });
            if (error) return null;
            const nome = String(data?.nome ?? '').trim();
            return nome || null;
        } catch {
            return null;
        }
    })();
    const comLimite = Promise.race([
        consulta,
        new Promise<null>(r => setTimeout(() => r(null), LIMITE_MS)),
    ]);
    // Falha não fica no cache: a próxima tentativa pode dar certo.
    const resultado = comLimite.then(nome => { if (!nome) cache.delete(doc); return nome; });
    cache.set(doc, resultado);
    return resultado;
}
